import { useMemo } from 'react';
export function useStepperHorizontal({ activeStep = 0, steps, }) {
    const getDividerClassName = useMemo(() => (idx) => {
        if (activeStep > idx)
            return 'dividerSuccess';
        if (idx === activeStep)
            return 'dividerActive';
        return 'dividerDisabled';
    }, [activeStep]);
    const getGroupClassName = useMemo(() => (idx) => {
        if (activeStep > idx)
            return 'groupSuccess';
        if (idx === activeStep || steps[idx].hasError)
            return 'groupActive';
        return 'groupDisabled';
    }, [activeStep, steps]);
    const getStepClassName = useMemo(() => (idx) => {
        return idx === activeStep ? 'stepperHorizontalStepsActive' : 'stepperHorizontalStepsDisabled';
    }, [activeStep]);
    const getStepTitleClassName = useMemo(() => (idx) => {
        return idx === activeStep ? 'stepTitleActive' : 'stepTitleDisabled';
    }, [activeStep]);
    const getStepContent = useMemo(() => (idx) => {
        if (steps[idx].hasError)
            return 'hexagonErrorWhite';
        return activeStep > idx ? 'checkMark' : idx + 1;
    }, [activeStep, steps]);
    return {
        getDividerClassName,
        getGroupClassName,
        getStepClassName,
        getStepTitleClassName,
        getStepContent,
    };
}
